export const LOCALES = {
  EN: 'en',
  JA: 'ja',
  JA_JP: 'ja-JP',
};

export const LOCALES_LIST = Object.values(LOCALES);
export const DEFAULT_LOCALE = LOCALES.EN;
export const LOCALE_DETECTION = true;
